// Yandex Maps loader & geolocation helper extracted from App.js to keep the
// main module compact. Kept as separate functions so any component (map
// picker, task map, journalist verification flow etc.) can import them.

export const loadYandexMaps = () => {
  return new Promise((resolve, reject) => {
    if (window.ymaps) {
      resolve(window.ymaps);
      return;
    }

    // Check if script is already loading
    if (document.querySelector('script[src*="api-maps.yandex.ru"]')) {
      const checkYmaps = setInterval(() => {
        if (window.ymaps) {
          clearInterval(checkYmaps);
          resolve(window.ymaps);
        }
      }, 100);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    script.onload = () => {
      if (window.ymaps) {
        window.ymaps.ready(() => {
          resolve(window.ymaps);
        });
      } else {
        reject(new Error('Yandex Maps API not loaded'));
      }
    };
    script.onerror = () => {
      reject(new Error('Failed to load Yandex Maps API'));
    };
    document.head.appendChild(script);
  });
};

// Резервное геокодирование адреса прямо в браузере через Яндекс.Карты JS API.
// Используется, когда серверный геокодер (Nominatim/OSM) временно недоступен —
// например, из-за сетевых ограничений на стороне хостинга. Работает через уже
// загруженный ymaps, поэтому не требует отдельного API-ключа геокодера.
export const geocodeAddressClientSide = async (address) => {
  const ymaps = await loadYandexMaps();
  const geocodeResult = await ymaps.geocode(address, { results: 1 });
  const firstGeoObject = geocodeResult.geoObjects.get(0);
  if (!firstGeoObject) {
    throw new Error('Address not found via Yandex geocoder');
  }
  const coords = firstGeoObject.geometry.getCoordinates();
  return { latitude: coords[0], longitude: coords[1] };
};

// Get user's current location
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 300000
      }
    );
  });
};
